/**
 * ShaderRegisterData contains the "named" registers, generated by the compiler and to be passed on to the methods.
 */
var ShaderRegisterData = /** @class */ (function () {
    function ShaderRegisterData() {
        this.textures = new Array();
        this.animatableAttributes = new Array();
        this.animationTargetRegisters = new Array();
    }
    return ShaderRegisterData;
}());
export { ShaderRegisterData };
